var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "header__search",
      class: { "header__search--open": _vm.openSearch }
    },
    [
      _c("form", { attrs: { action: _vm.action, method: "POST" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "on-clickaway",
                rawName: "v-on-clickaway",
                value: _vm.away,
                expression: "away"
              }
            ],
            staticClass: "search-form"
          },
          [
            _c("input", {
              attrs: { type: "hidden", name: "_token", id: "csrf-token" },
              domProps: { value: _vm.token }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: "XXXXXXXXXX",
                  expression: "'XXXXXXXXXX'"
                }
              ],
              ref: "search",
              staticClass: "browser-default search-form__field",
              class: { "search-form__field--open": _vm.openSearch },
              attrs: { name: "search", type: "text", placeholder: "Buscar..." }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "search-form__button",
                on: { click: _vm.toggleSearch }
              },
              [
                _c("i", {
                  staticClass: "fa",
                  class: _vm.openSearch ? "fa-close" : "fa-search",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-435ac42c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435ac42c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/menu/Search.vue
// module id = 354
// module chunks = 0